import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: "streamdate"})
export class StreamDate implements PipeTransform {
    transform(value: any) {
        value = new Date(value);
        return `${value.toLocaleDateString()} ${value.toLocaleTimeString()}`.toString()
    }
}